import { get } from 'lodash'

export const getCurrentMenuId = (state) => get(state, 'appState.currentMenuId')

export const getIsAccessibilityRequired = (state) => state?.appState?.isAccessibilityRequired ?? false

export const getSafMode = (state) => state?.appState?.safMode ?? 0

export const getSafForcedByPlatform = (state) => !!state?.appState?.safForcedByPlatform

export const getSafResponse = (state) => state?.appState?.safResponse ?? { success: true, message: null }

export const getErrorInfo = (state) => state?.appState?.errorInfo ?? {}

export const getRemoteVersion = (state) => {
  return state?.appState?.remoteVersion ?? null
}
